<template>
    <div v-if="data.length === 0">
        <i>{{ $trans('web_search.profile_card.no_content') }}</i>
    </div>
    <template v-else>
        <div class="profile-card-competencies">
            <template v-for="(record, index) in visibleData" :key="index">
                <div class="profile-card-competencies-item">
                    <div class="title">{{ record.job_tag_name }} / <span class="title-duration">{{ record.duration_in_month_text }}</span></div>
                    <ProfileProgressBar
                        :percentage="record.duration_percentage"
                    />
                </div>
            </template>
            <div class="show-more-button-wrapper" v-if="data.length > defaultLength">
                <div
                    class="show-more-button"
                    @click="maxLength += step"
                    v-if="maxLength < data.length"
                >
                    {{ $trans('web_search.filters.show_more') }}
                </div>
                <div
                    class="show-less-button"
                    @click="maxLength = defaultLength"
                    v-if="maxLength >= data.length"
                >
                    {{ $trans('web_search.filters.show_less') }}
                </div>
            </div>
        </div>
    </template>
</template>

<script>
import ProfileProgressBar from './ProfileProgressBar.vue';

export default {
    components: {
        ProfileProgressBar,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            defaultLength: 5,
            maxLength: 5,
            step: 5,
        };
    },
    computed: {
        visibleData() {
            return this.data.slice(0, this.maxLength);
        },
    },
};
</script>

<style scoped>
.profile-card-competencies {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.profile-card-competencies-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.show-more-button,
.show-less-button {
    cursor: pointer;
    font-size: 14px;
    color: #41ABC4;
    margin-top: 10px;
}

.show-more-button:hover,
.show-less-button:hover {
    color: #2E7282;
}

.title {
    text-align: left;
    font: normal normal normal 15px/22px Barlow;
    letter-spacing: -0.27px;
    color: #343433;
    opacity: 1;
}

.title-duration {
    font: normal normal normal 13px/22px Barlow;
}

.show-more-button-wrapper {
    display: flex;
    justify-content: flex-end;
}
</style>
